import React from "react";
import { IEmojiSelector } from "./EmojiSelector.types";
import AddReactionOutlinedIcon from "@mui/icons-material/AddReactionOutlined";
import { styles } from "./EmojiSelector.styles";
import { useIsDesktop } from "../../../../../../utils/common/screen";
import ExlyEmojiPicker from "../../../ExlyEmojiPicker/ExlyEmojiPicker";
import Popover from "../../../../../../components/common/Popover/Popover";
import { EmojiStyle } from "emoji-picker-react";

const EmojiSelector = ({
  handleEmojiSelect,
}: IEmojiSelector.IEmojiSelectorProps) => {
  const isDesktop = useIsDesktop();
  return (
    <Popover
      wrapperClassName={styles.wrapper}
      AnchorComponent={({ openPopover }) => (
        <AddReactionOutlinedIcon
          onClick={openPopover}
          className={styles.emojiAnchor}
        />
      )}
      PopoverComponent={({ closePopover }) => (
        <ExlyEmojiPicker
          onEmojiClick={(emojiData, event) => {
            /**
             * Keeping the order of assign after closePopover.
             * Why? on click action use to take the popover on top left so
             * now on single click first close popover then add the emoji which
             * eventually led to close of popover before it moved to top left.
             */
            closePopover(event as unknown as React.MouseEvent<Element>);
            handleEmojiSelect(emojiData.emoji);
          }}
          emojiStyle={EmojiStyle.NATIVE}
          {...(isDesktop ? {} : { width: "100vw", autoFocusSearch: false })}
        />
      )}
      popoverProps={{
        anchorOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
      }}
    />
  );
};

export default EmojiSelector;
